import api from "./axiosConfig";

// Get saved credit cards for a passenger by ID - per backend instructions
export const getCreditCardsByPassengerId = async (passengerId) => {
  const start = Date.now();
  
  try {
    console.log('[API] Getting saved credit cards for passenger:', passengerId);
    const response = await api.get(`/quote_api/get_creditcards/${passengerId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    const end = Date.now();
    console.log(`[API] /quote_api/get_creditcards/${passengerId} response time: ${end - start} ms`);
    console.log('[API] Credit cards response:', response.data);
    
    return response.data;
  } catch (error) {
    const end = Date.now();
    console.log(`[API] /quote_api/get_creditcards/${passengerId} response time (error): ${end - start} ms`);
    console.error("Error getting credit cards:", error);
    throw error;
  }
};

// Get saved credit cards for a passenger by phone number - per backend instructions
export const getCreditCardsByPhone = async (phoneNumber) => {
  const start = Date.now();
  
  try {
    console.log('[API] Getting saved credit cards for phone:', phoneNumber);
    const response = await api.get(`/quote_api/get_creditcards_by_phone/${phoneNumber}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    const end = Date.now();
    console.log(`[API] /quote_api/get_creditcards_by_phone/${phoneNumber} response time: ${end - start} ms`);
    console.log('[API] Credit cards by phone response:', response.data);
    
    return response.data;
  } catch (error) {
    const end = Date.now();
    console.log(`[API] /quote_api/get_creditcards_by_phone/${phoneNumber} response time (error): ${end - start} ms`);
    console.error("Error getting credit cards by phone:", error);
    throw error;
  }
};
